export default __webpack_public_path__ + "static/media/HeroImage3.64bc5667.png";